// Generated by Go - DO NOT EDIT
// 2026-11-03 13:22:03.908541306 +0000 UTC m=+0.002996253

const expenseRefundCategories = [
  {
    "id": 10,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Annoncen"
  },
  {
    "id": 20,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Anschaffung von Gartengeräten"
  },
  {
    "id": 30,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Anwaltskosten"
  },
  {
    "id": 40,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Bank und Kontoführungsgebühren"
  },
  {
    "id": 50,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Beseitigung Verstopfung (Abwasser)"
  },
  {
    "id": 60,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Betriebskosten leerstehende Wohnungen"
  },
  {
    "id": 70,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Dachrinnenreinigung"
  },
  {
    "id": 80,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Darlehensrate"
  },
  {
    "id": 90,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Darlehenstilgung"
  },
  {
    "id": 100,
    "anlage_v_category": 1,
    "apportionable": false,
    "description": "Darlehenszinsen"
  },
  {
    "id": 110,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Ersatzteile (Aufzüge)"
  },
  {
    "id": 120,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Fahrtkosten"
  },
  {
    "id": 130,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Gebühren für Rücklastschrift"
  },
  {
    "id": 140,
    "anlage_v_category": 3,
    "apportionable": false,
    "description": "Hausgeld"
  },
  {
    "id": 150,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Heizkostenanteile (leerstehende Wohnungen)"
  },
  {
    "id": 160,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Installation von Feuerlöschern"
  },
  {
    "id": 170,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Kapitalertragsteuer"
  },
  {
    "id": 180,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Kosten für Störungsdienst (Aufzug)"
  },
  {
    "id": 190,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Mitgliedsbeiträge Eigentümerverband"
  },
  {
    "id": 200,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Möbel mit Wert \u003c 800 Euro"
  },
  {
    "id": 210,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Porto"
  },
  {
    "id": 220,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Rechts und Beratungskosten"
  },
  {
    "id": 230,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Reparatur Heizung"
  },
  {
    "id": 240,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Reparatur Reinigungsmaschinen"
  },
  {
    "id": 250,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Reparatur Fliesen"
  },
  {
    "id": 260,
    "anlage_v_category": 3,
    "apportionable": false,
    "description": "Rückerstattung Betriebskosten"
  },
  {
    "id": 270,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Schönheitsreparaturen"
  },
  {
    "id": 280,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Sollzinsen"
  },
  {
    "id": 290,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Sonstige Ausgaben (nicht steuerlich absetzbar)"
  },
  {
    "id": 300,
    "anlage_v_category": 5,
    "apportionable": false,
    "description": "Sonstige Ausgaben (steuerlich absetzbar)"
  },
  {
    "id": 310,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Sonstige Instandhaltungskosten"
  },
  {
    "id": 320,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Sonstige Reparaturkosten"
  },
  {
    "id": 330,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Steuerberatungskosten"
  },
  {
    "id": 340,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Strom (nicht umlagefähig)"
  },
  {
    "id": 350,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Telefonkosten"
  },
  {
    "id": 360,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Trinkgelder"
  },
  {
    "id": 370,
    "anlage_v_category": 6,
    "apportionable": false,
    "description": "Umbuchung"
  },
  {
    "id": 380,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Verwaltungskosten"
  },
  {
    "id": 390,
    "anlage_v_category": 2,
    "apportionable": false,
    "description": "Wartung Klingel"
  },
  {
    "id": 400,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Wasser (nicht umlagefähig)"
  },
  {
    "id": 410,
    "anlage_v_category": 4,
    "apportionable": false,
    "description": "Wasserkosten durch Wasserleitungsschaden"
  },
  {
    "id": 420,
    "anlage_v_category": 3,
    "apportionable": false,
    "description": "Weitergegebene Kosten"
  },
  {
    "id": 1010,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Allgemeinstrom"
  },
  {
    "id": 1020,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Aufzug"
  },
  {
    "id": 1030,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Außenanlagen"
  },
  {
    "id": 1040,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Breitband / Kabel / Satellitenanlage"
  },
  {
    "id": 1050,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Entwässerung"
  },
  {
    "id": 1060,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Feuerversicherung"
  },
  {
    "id": 1070,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Flurbeleuchtung"
  },
  {
    "id": 1080,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Flurreinigung"
  },
  {
    "id": 1090,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Gartenpflege"
  },
  {
    "id": 10100,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Gebäudeversicherung"
  },
  {
    "id": 10110,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Gemeinschaftsantenne"
  },
  {
    "id": 10120,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Glasversicherung"
  },
  {
    "id": 10130,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Grundgebühren Kabelanschluss"
  },
  {
    "id": 10140,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Grundsteuer"
  },
  {
    "id": 10150,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Haftpflichtversicherung"
  },
  {
    "id": 10160,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Hauswart"
  },
  {
    "id": 10170,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Kaltwasser"
  },
  {
    "id": 10180,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Regenwasser"
  },
  {
    "id": 10190,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Schornsteinfeger"
  },
  {
    "id": 10200,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Müllabfuhr"
  },
  {
    "id": 10210,
    "anlage_v_category": 5,
    "apportionable": true,
    "description": "Sonstiges"
  },
  {
    "id": 10220,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Straßenreinigung"
  },
  {
    "id": 10230,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Treppenhausreinigung"
  },
  {
    "id": 10240,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Ungezieferbekämpfung"
  },
  {
    "id": 10250,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Versicherung"
  },
  {
    "id": 10260,
    "anlage_v_category": 2,
    "apportionable": true,
    "description": "Wartung Brandschutz"
  },
  {
    "id": 10270,
    "anlage_v_category": 2,
    "apportionable": true,
    "description": "Wartung Heizung"
  },
  {
    "id": 10280,
    "anlage_v_category": 2,
    "apportionable": true,
    "description": "Wartung Lüftung"
  },
  {
    "id": 10290,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Winterdienst"
  },
  {
    "id": 10300,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Heizung"
  },
  {
    "id": 10310,
    "anlage_v_category": 3,
    "apportionable": true,
    "description": "Strom"
  }
];

const expenseAndRefundAllocationKeys = [
  {
    "id": 1,
    "key": "sqm",
    "description": "Wohnfläche"
  },
  {
    "id": 2,
    "key": "persons",
    "description": "Personen"
  },
  {
    "id": 3,
    "key": "units",
    "description": "Wohneinheiten"
  },
  {
    "id": 4,
    "key": "consumption",
    "description": "Verbrauch"
  },
  {
    "id": 5,
    "key": "direct",
    "description": "Direkt"
  }
];

const anlageVCategories = [
  {
    "id": 1,
    "description": "Geldbeschaffungskosten"
  },
  {
    "id": 2,
    "description": "Erhaltungsaufwendungen"
  },
  {
    "id": 3,
    "description": "Umgelegte Kosten"
  },
  {
    "id": 4,
    "description": "Nicht umgelegte Kosten"
  },
  {
    "id": 5,
    "description": "Sonstige Kosten"
  },
  {
    "id": 6,
    "description": ""
  }
];

const allocationKeys = {
  "Consumption": 4,
  "Direct": 5,
  "None": 0,
  "Persons": 2,
  "Sqm": 1,
  "Units": 3
};

export { expenseRefundCategories, expenseAndRefundAllocationKeys, anlageVCategories, allocationKeys };